module.exports = __webpack_public_path__ + "img/Latex - Application2.25a701d4.png";